export interface LoaderScriptLike {
  dataset: {
    apiBase?: string;
    runtimeBase?: string;
  };
  src: string;
}

export function resolveApiBase(script: LoaderScriptLike): string {
  if (script.dataset.apiBase) {
    return script.dataset.apiBase.replace(/\/$/, '');
  }
  try {
    return new URL(script.src).origin;
  } catch {
    return globalThis.location?.origin ?? 'http://localhost';
  }
}

export function resolveRuntimeBase(script: LoaderScriptLike): string {
  if (script.dataset.runtimeBase) {
    return script.dataset.runtimeBase.replace(/\/$/, '');
  }
  try {
    const url = new URL(script.src);
    return `${url.origin}${url.pathname.replace(/\/loader\.js$/, '')}`;
  } catch {
    return '/runtime';
  }
}
